import {
  REFRESH_POSITIONS,
	SET_POSITIONS,
  ADD_POSITIONS
} from './types';

export const setRefreshPositions = () => {
	return {
    type: REFRESH_POSITIONS,
    payload: [],
  };
}

export const setPositions = (params) => {
	return {
    type: SET_POSITIONS,
    payload: params,
  };
}

export const addPositions = (params) => {
	return {
    type: ADD_POSITIONS,
    payload: params,
  };
}